/* Word-start matching for the instant suggestions: every typed word must be the START of a word in the text
   ("tim" finds "Time Clock", not "esTIMates"; "clock rep" finds "Time Clock Replacement"). Case does not matter.
   A word starts at the beginning of the text or after anything that is not a letter or digit (space, -, /, (, …). */
export const queryWords = (s: string): string[] => s.toLowerCase().split(/\s+/).filter(Boolean);

const ALNUM = /[\p{L}\p{N}]/u;
/** where `w` (lower case) starts a word in `text` */
function startsIn(text: string, w: string): number[] {
  const low = text.toLowerCase(), out: number[] = [];
  for (let i = low.indexOf(w); i >= 0; i = low.indexOf(w, i + 1))
    if (i === 0 || !ALNUM.test(low[i - 1])) out.push(i);
  return out;
}
/** does every word start a word somewhere in the text? */
export function matchesAll(text: string, q: string[]): boolean { return q.every(w => startsIn(text, w).length > 0); }

/** the text as HTML (escaped) with each matched word start in <mark> (the reason it is suggested) */
export function markStarts(text: string, q: string[], esc: (s: string) => string): string {
  const hit = new Array<boolean>(text.length).fill(false);
  for (const w of q) for (const i of startsIn(text, w)) for (let k = i; k < i + w.length; k++) hit[k] = true;
  let html = '', i = 0;
  while (i < text.length) {
    let j = i; while (j < text.length && hit[j] === hit[i]) j++;
    html += hit[i] ? '<mark>' + esc(text.slice(i, j)) + '</mark>' : esc(text.slice(i, j));
    i = j;
  }
  return html;
}
